export default {
  methods: {
    getFormRows (form) {
      let rows = [], row
      form.forEach(item => {
        let span = this.getFormItemSpan(item)
        if (!row || row.span >= 24 || row.span + span > 24) {
          row = []
          row.span = 0
          rows.push(row)
        }
        row.span += span
        row.push(item)
      })
      return rows
    },
    getFormItemSpan (item) {
      return (item.type === 'file' || item.type === 'select' && item.multiple) ? 24 : 12
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/achievement/formRowMixin.js